import { render, staticRenderFns } from "./food-edit.vue?vue&type=template&id=dfc415e2&"
import script from "./food-edit.vue?vue&type=script&lang=ts&"
export * from "./food-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports